//import React from "react";
import { NavigateFunction, RouteObject, Outlet } from "react-router-dom";
import { XML, Farms, Users } from "../../../Containers/index";
import TabMenu from "../../Menus/tabMenu";
import GraphQl from "../../../Containers/ToolsScreens/GraphQl/logsndata";

/* eslint-disable */
export enum Pages {
  home="./",

  graphQl="GraphQl",

  xml = "xml",
  
  farms = "farms",

  users = "users"
}
/* eslint-enable */

export const Router = [{
  element: null,
  children: [
    { path:`/${Pages.graphQl}`, element:<TabMenu key={Pages.graphQl} main={Pages.graphQl} overrides={{ base_alternative: Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, path:`/${Pages.graphQl}/*`, element:<GraphQl/>}
      ]
    },
    { path:`/${Pages.xml}`, element:<TabMenu key={Pages.xml} main={Pages.xml} overrides={{ base_alternative: Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, path:`/${Pages.xml}/*`, element:<XML/>}
      ]
    },
    { path:`/${Pages.farms}`, element:<TabMenu key={Pages.farms} main={Pages.farms} overrides={{ base_alternative: Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, path:`/${Pages.farms}/*`, element:<Farms/>}
      ]
    },
    { path:`/${Pages.users}`, element:<TabMenu key={Pages.users} main={Pages.users} overrides={{ base_alternative: Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, path:`/${Pages.users}/*`, element:<Users/>}
      ]
    }
  ]
}] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page:Pages, navigation_sub?:Pages) => {
  switch (navigation_page) {
    case Pages.home:
      Navigator(Pages.home)
    break
    case Pages.graphQl:
      Navigator("../"+Pages.graphQl, {state:{global_index:0, tab: 0}})
    break
    case Pages.xml:
      Navigator("../"+Pages.xml, {state: {tools_index:1, tab:0}})
    break
    case Pages.farms:
      Navigator("../"+Pages.farms, {state: {tools_index:2, tab:0}})
    break
    case Pages.users:
      Navigator("../"+Pages.users, {state: {tools_index:3, tab:0}})
    break
    default:
      console.log("Error page not found (404)???, [ToolsMenu]")
  }
}
